// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"9dQ28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
var _react = require("react");
"use client";
function Example() {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set([
        'cheese'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBox), {
                "aria-label": "Sandwich contents",
                selectionMode: "multiple",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        id: "lettuce",
                        children: "Lettuce"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        id: "tomato",
                        children: "Tomato"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        id: "cheese",
                        children: "Cheese"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        id: "tuna",
                        children: "Tuna Salad"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        id: "egg",
                        children: "Egg Salad"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                        id: "ham",
                        children: "Ham"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKeys: ",
                    selectedKeys === 'all' ? 'all' : [
                        ...selectedKeys
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kNiGV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ListBox", ()=>ListBox);
parcelHelpers.export(exports, "ListBoxItem", ()=>ListBoxItem);
parcelHelpers.export(exports, "ListBoxSection", ()=>ListBoxSection);
parcelHelpers.export(exports, "DropdownItem", ()=>DropdownItem);
parcelHelpers.export(exports, "ListBoxLoadMoreItem", ()=>ListBoxLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _lucideReact = require("lucide-react");
var _content = require("./Content");
var _progressCircle = require("./ProgressCircle");
var _listBoxCss = require("./ListBox.css");
'use client';
function ListBox({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBox), {
        ...props,
        children: children
    });
}
function ListBoxItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxItem), {
        ...props,
        textValue: textValue,
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children)=>typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "label",
                children: children
            }) : children)
    });
}
function ListBoxSection(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxSection), {
        ...props
    });
}
function DropdownItem(props) {
    let textValue = props.textValue || (typeof props.children === 'string' ? props.children : undefined);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ListBoxItem, {
        ...props,
        textValue: textValue,
        className: "dropdown-item",
        children: (0, _reactAriaComponents.composeRenderProps)(props.children, (children, { isSelected })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.Check), {}),
                    typeof children === 'string' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                        slot: "label",
                        children: children
                    }) : children
                ]
            }))
    });
}
function ListBoxLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ListBoxLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading more..."
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["ListBox","dNdIK"],["ListBoxItem","dNdIK"],["ListBoxLoadMoreItem","dNdIK"],["ListBoxSection","dNdIK"]],"lucide-react":[["Check","9PYFQ","default"]],"./Content":"jYtLe","./ProgressCircle":"c08Ay","./ListBox.css":"bDSGu","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9PYFQ":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>Check);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const Check = (0, _createLucideIconJsDefault.default)("check", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gsSty":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createLucideIcon);
var _react = require("react");
var _utilsJs = require("./shared/src/utils.js");
var _iconJs = require("./Icon.js");
var _iconJsDefault = parcelHelpers.interopDefault(_iconJs);
const createLucideIcon = (iconName, iconNode)=>{
    const Component = (0, _react.forwardRef)(({ className, ...props }, ref)=>(0, _react.createElement)((0, _iconJsDefault.default), {
            ref,
            iconNode,
            className: (0, _utilsJs.mergeClasses)(`lucide-${(0, _utilsJs.toKebabCase)((0, _utilsJs.toPascalCase)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, _utilsJs.toPascalCase)(iconName);
    return Component;
};

},{"react":"a1TxN","./shared/src/utils.js":"lfP1m","./Icon.js":"d0fsO","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"lfP1m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasA11yProp", ()=>hasA11yProp);
parcelHelpers.export(exports, "mergeClasses", ()=>mergeClasses);
parcelHelpers.export(exports, "toCamelCase", ()=>toCamelCase);
parcelHelpers.export(exports, "toKebabCase", ()=>toKebabCase);
parcelHelpers.export(exports, "toPascalCase", ()=>toPascalCase);
const toKebabCase = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
const toCamelCase = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());
const toPascalCase = (string)=>{
    const camelCase = toCamelCase(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};
const mergeClasses = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();
const hasA11yProp = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"d0fsO":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
var _defaultAttributesJs = require("./defaultAttributes.js");
var _defaultAttributesJsDefault = parcelHelpers.interopDefault(_defaultAttributesJs);
var _utilsJs = require("./shared/src/utils.js");
const Icon = (0, _react.forwardRef)(({ color = "currentColor", size = 24, strokeWidth = 2, absoluteStrokeWidth, className = "", children, iconNode, ...rest }, ref)=>(0, _react.createElement)("svg", {
        ref,
        ...(0, _defaultAttributesJsDefault.default),
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth ? Number(strokeWidth) * 24 / Number(size) : strokeWidth,
        className: (0, _utilsJs.mergeClasses)("lucide", className),
        ...!children && !(0, _utilsJs.hasA11yProp)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, _react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]));

},{"react":"a1TxN","./defaultAttributes.js":"9Rm8m","./shared/src/utils.js":"lfP1m","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9Rm8m":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>defaultAttributes);
var defaultAttributes = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jYtLe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Heading", ()=>Heading);
parcelHelpers.export(exports, "Text", ()=>Text);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _contentCss = require("./Content.css");
function Heading(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Heading), {
        ...props
    });
}
function Text(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Heading","2f4nH"],["Text","jt9fm"]],"./Content.css":"kvyv3","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvyv3":[function() {},{}],"c08Ay":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgressCircle", ()=>ProgressCircle);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
'use client';
function ProgressCircle(props) {
    // SVG strokes are centered, so subtract half the stroke width from the radius to create an inner stroke.
    let strokeWidth = 4;
    let radius = `calc(50% - ${strokeWidth / 2}px)`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ProgressBar), {
        ...props,
        style: (0, _reactAriaComponents.composeRenderProps)(props.style, (style)=>({
                ...style,
                width: props.size || 16,
                height: props.size || 16
            })),
        children: ({ percentage, isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    fill: "none",
                    width: "100%",
                    height: "100%",
                    viewBox: "0 0 32 32",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-pressed)",
                            strokeWidth: strokeWidth
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "50%",
                            cy: "50%",
                            r: radius,
                            stroke: "var(--highlight-background)",
                            strokeWidth: strokeWidth,
                            // Normalize the path length to 100 so we can easily set stroke-dashoffset to a percentage.
                            pathLength: "100",
                            // Add extra gap between dashes so 0% works in Chrome.
                            strokeDasharray: "100 200",
                            strokeDashoffset: 100 - (isIndeterminate || percentage == null ? 25 : percentage),
                            strokeLinecap: "round",
                            style: {
                                rotate: '-90deg',
                                transformOrigin: 'center center'
                            },
                            children: isIndeterminate && /*#__PURE__*/ (0, _jsxRuntime.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                dur: "0.75s",
                                values: "0;360",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["composeRenderProps","bA6Cz"],["ProgressBar","kPGON"]],"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bDSGu":[function() {},{}],"4v7yX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Example);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
"use client";
function Example() {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set([
        'Blastoise'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridList), {
                "aria-label": "Sandwich contents",
                selectionMode: "multiple",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                "data-size": "small",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PokemonItem, {
                        name: "Charizard"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PokemonItem, {
                        name: "Blastoise"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PokemonItem, {
                        name: "Venusaur"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PokemonItem, {
                        name: "Pikachu"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKeys: ",
                    selectedKeys === 'all' ? 'all' : [
                        ...selectedKeys
                    ].join(', ')
                ]
            })
        ]
    });
}
function PokemonItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
        id: props.name,
        textValue: props.name,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: `https://img.pokemondb.net/sprites/home/normal/2x/avif/${props.name.toLowerCase()}.avif`
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                children: props.name
            })
        ]
    });
}

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":"jt9fm","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hvGD4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GridList", ()=>GridList);
parcelHelpers.export(exports, "GridListItem", ()=>GridListItem);
parcelHelpers.export(exports, "GridListLoadMoreItem", ()=>GridListLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _lucideReact = require("lucide-react");
var _progressCircle = require("./ProgressCircle");
var _gridListCss = require("./GridList.css");
'use client';
function GridList({ children, layout = 'grid', ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridList), {
        ...props,
        layout: layout,
        children: children
    });
}
function GridListItem({ children, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridListItem), {
        textValue: textValue,
        ...props,
        children: ({ selectionMode, selectionBehavior, allowsDragging })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "drag",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.GripVertical), {
                            size: 16
                        })
                    }),
                    selectionMode === 'multiple' && selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                        slot: "selection"
                    }),
                    children
                ]
            })
    });
}
function GridListLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.GridListLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading more..."
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["GridList","8bLgh"],["GridListItem","8bLgh"],["GridListLoadMoreItem","8bLgh"]],"./Checkbox":"eZZAR","lucide-react":[["GripVertical","1JqDe","default"]],"./ProgressCircle":"c08Ay","./GridList.css":"36Tst","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eZZAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkboxCss = require("./Checkbox.css");
'use client';
function Checkbox({ children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Checkbox), {
        ...props,
        children: ({ isIndeterminate })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "indicator",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            viewBox: "0 0 18 18",
                            "aria-hidden": "true",
                            children: isIndeterminate ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: 1,
                                y: 7.5,
                                width: 16,
                                height: 3
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                points: "2 9 7 14 16 4"
                            })
                        }, isIndeterminate ? 'indeterminate' : 'check')
                    }),
                    children
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"9jC2J","./Checkbox.css":"2wQgb","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2wQgb":[function() {},{}],"1JqDe":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>GripVertical);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "circle",
        {
            cx: "9",
            cy: "12",
            r: "1",
            key: "1vctgf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "5",
            r: "1",
            key: "hp0tcf"
        }
    ],
    [
        "circle",
        {
            cx: "9",
            cy: "19",
            r: "1",
            key: "fkjjf6"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "12",
            r: "1",
            key: "1tmaij"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "5",
            r: "1",
            key: "19l28e"
        }
    ],
    [
        "circle",
        {
            cx: "15",
            cy: "19",
            r: "1",
            key: "f4zoj3"
        }
    ]
];
const GripVertical = (0, _createLucideIconJsDefault.default)("grip-vertical", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"36Tst":[function() {},{}],"8nyqY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
var _react = require("react");
"use client";
function Example() {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set([
        'project'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tree.Tree), {
                "aria-label": "Files",
                defaultExpandedKeys: [
                    'documents',
                    'photos',
                    'project'
                ],
                selectionMode: "multiple",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                        id: "documents",
                        title: "Documents",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                            id: "project",
                            title: "Project",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                                title: "Weekly Report"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tree.TreeItem), {
                        id: "photos",
                        title: "Photos",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                                title: "Image 1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                                title: "Image 2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKeys: ",
                    selectedKeys === 'all' ? 'all' : [
                        ...selectedKeys
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ifc8k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Tree", ()=>Tree);
parcelHelpers.export(exports, "TreeItemContent", ()=>TreeItemContent);
parcelHelpers.export(exports, "TreeItem", ()=>TreeItem);
parcelHelpers.export(exports, "TreeLoadMoreItem", ()=>TreeLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _lucideReact = require("lucide-react");
var _checkbox = require("./Checkbox");
var _progressCircle = require("./ProgressCircle");
var _treeCss = require("./Tree.css");
'use client';
function Tree(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tree), {
        ...props
    });
}
function TreeItemContent(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TreeItemContent), {
        children: ({ selectionBehavior, selectionMode, allowsDragging })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "drag",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.GripVertical), {
                            size: 16
                        })
                    }),
                    selectionBehavior === 'toggle' && selectionMode !== 'none' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                        slot: "selection"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "chevron",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronRight), {})
                    }),
                    props.children
                ]
            })
    });
}
function TreeItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TreeItem), {
        textValue: props.title,
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TreeItemContent, {
                children: props.title
            }),
            props.children
        ]
    });
}
function TreeLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TreeLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
            isIndeterminate: true,
            "aria-label": "Loading more..."
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Tree","kwlwT"],["TreeItem","kwlwT"],["TreeItemContent","kwlwT"],["TreeLoadMoreItem","kwlwT"]],"lucide-react":[["ChevronRight","elAlB","default"],["GripVertical","1JqDe","default"]],"./Checkbox":"eZZAR","./ProgressCircle":"c08Ay","./Tree.css":"3VY5L","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"elAlB":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronRight);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m9 18 6-6-6-6",
            key: "mthhwq"
        }
    ]
];
const ChevronRight = (0, _createLucideIconJsDefault.default)("chevron-right", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"3VY5L":[function() {},{}],"8DsPC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
var _react = require("react");
"use client";
function Example() {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set([
        'cheese'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
                label: "Sandwich contents",
                selectionMode: "multiple",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "lettuce",
                        children: "Lettuce"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "tomato",
                        children: "Tomato"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "cheese",
                        children: "Cheese"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "tuna",
                        children: "Tuna Salad"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "egg",
                        children: "Egg Salad"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                        id: "ham",
                        children: "Ham"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKeys: ",
                    selectedKeys === 'all' ? 'all' : [
                        ...selectedKeys
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eq0FG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TagGroup", ()=>TagGroup);
parcelHelpers.export(exports, "Tag", ()=>Tag);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _form = require("./Form");
var _content = require("./Content");
var _lucideReact = require("lucide-react");
var _tagGroupCss = require("./TagGroup.css");
'use client';
function TagGroup({ label, description, errorMessage, items, children, renderEmptyState, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TagGroup), {
        ...props,
        children: [
            label && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TagList), {
                items: items,
                renderEmptyState: renderEmptyState,
                children: children
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Description), {
                children: description
            }),
            errorMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
                slot: "errorMessage",
                children: errorMessage
            })
        ]
    });
}
function Tag({ children, ...props }) {
    let textValue = typeof children === 'string' ? children : undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Tag), {
        textValue: textValue,
        ...props,
        className: "react-aria-Tag button-base",
        children: ({ allowsRemoving })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    children,
                    allowsRemoving && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                        slot: "remove",
                        className: "remove-button",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.X), {})
                    })
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Tag","dIN55"],["TagGroup","dIN55"],["TagList","dIN55"]],"./Form":"6qejZ","./Content":"jYtLe","lucide-react":[["X","1gkBb","default"]],"./TagGroup.css":"72EEe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6qejZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "FieldError", ()=>FieldError);
parcelHelpers.export(exports, "Description", ()=>Description);
parcelHelpers.export(exports, "FieldButton", ()=>FieldButton);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _formCss = require("./Form.css");
var _content = require("./Content");
'use client';
function Form(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Form), {
        ...props
    });
}
function Label(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Label), {
        ...props
    });
}
function FieldError(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.FieldError), {
        ...props
    });
}
function Description(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _content.Text), {
        slot: "description",
        className: "field-description",
        ...props
    });
}
function FieldButton(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
        ...props,
        className: "field-Button"
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["FieldError","algyu"],["Form","g7RKA"],["Label","fjKq6"]],"./Form.css":"7sxTy","./Content":"jYtLe","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7sxTy":[function() {},{}],"1gkBb":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>X);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const X = (0, _createLucideIconJsDefault.default)("x", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"72EEe":[function() {},{}],"7CorQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _table = require("vanilla-starter/Table");
var _react = require("react");
"use client";
const rows = [
    {
        id: 'lettuce',
        name: 'Lettuce',
        type: 'Vegetable',
        calories: 4
    },
    {
        id: 'tomato',
        name: 'Tomato',
        type: 'Vegetable',
        calories: 5
    },
    {
        id: 'cheese',
        name: 'Cheddar',
        type: 'Cheese',
        calories: 113
    },
    {
        id: 'tuna',
        name: 'Tuna salad',
        type: 'Salad',
        calories: 187
    },
    {
        id: 'egg',
        name: 'Egg salad',
        type: 'Salad',
        calories: 200
    },
    {
        id: 'ham',
        name: 'Ham',
        type: 'Meat',
        calories: 205
    }
];
function Example() {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set([
        'cheese'
    ]));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
                "aria-label": "Sandwich contents",
                selectionMode: "multiple",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHeader), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                                isRowHeader: true,
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                                children: "Type"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                                children: "Calories"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
                        items: rows,
                        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: item.type
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                                        children: item.calories
                                    })
                                ]
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKeys: ",
                    selectedKeys === 'all' ? 'all' : [
                        ...selectedKeys
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Table":"ja8ai","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"ja8ai":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Table", ()=>Table);
parcelHelpers.export(exports, "Column", ()=>Column);
parcelHelpers.export(exports, "TableHeader", ()=>TableHeader);
parcelHelpers.export(exports, "Row", ()=>Row);
parcelHelpers.export(exports, "TableBody", ()=>TableBody);
parcelHelpers.export(exports, "Cell", ()=>Cell);
parcelHelpers.export(exports, "TableLoadMoreItem", ()=>TableLoadMoreItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("./Checkbox");
var _progressCircle = require("./ProgressCircle");
var _lucideReact = require("lucide-react");
var _tableCss = require("./Table.css");
'use client';
function Table(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Table), {
        ...props
    });
}
function Column(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
        ...props,
        className: "react-aria-Column button-base",
        children: ({ allowsSorting, sortDirection })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "column-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Group), {
                        role: "presentation",
                        tabIndex: -1,
                        className: "column-name",
                        children: props.children
                    }),
                    allowsSorting && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        "aria-hidden": "true",
                        className: "sort-indicator",
                        children: sortDirection === 'ascending' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronUp), {
                            size: 16
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            size: 16
                        })
                    }),
                    props.allowsResizing && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.ColumnResizer), {})
                ]
            })
    });
}
function TableHeader({ columns, children, ...otherProps }) {
    let { selectionBehavior, selectionMode, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableHeader), {
        ...otherProps,
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                width: 20,
                minWidth: 20,
                style: {
                    width: 20
                },
                className: "react-aria-Column button-base"
            }),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                width: 32,
                minWidth: 32,
                style: {
                    width: 32
                },
                className: "react-aria-Column button-base",
                children: selectionMode === 'multiple' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
function Row({ id, columns, children, ...otherProps }) {
    let { selectionBehavior, allowsDragging } = (0, _reactAriaComponents.useTableOptions)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Row), {
        id: id,
        ...otherProps,
        children: [
            allowsDragging && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Button), {
                    slot: "drag",
                    className: "drag-button",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.GripVertical), {})
                })
            }),
            selectionBehavior === 'toggle' && /*#__PURE__*/ (0, _jsxRuntime.jsx)(Cell, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                    slot: "selection"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: columns,
                children: children
            })
        ]
    });
}
function TableBody(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableBody), {
        ...props
    });
}
function Cell(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
        ...props
    });
}
function TableLoadMoreItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableLoadMoreItem), {
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressCircle.ProgressCircle), {
                isIndeterminate: true,
                "aria-label": "Loading more..."
            })
        })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["Button","9G5XO"],["Cell","3vnUd"],["Column","3vnUd"],["ColumnResizer","3vnUd"],["Row","3vnUd"],["Table","3vnUd"],["TableBody","3vnUd"],["TableHeader","3vnUd"],["TableLoadMoreItem","3vnUd"],["useTableOptions","3vnUd"],["Collection","2Jd0Q"],["Group","6UspO"]],"./Checkbox":"eZZAR","./ProgressCircle":"c08Ay","lucide-react":[["ChevronDown","kWVt3","default"],["ChevronUp","kvLo9","default"],["GripVertical","1JqDe","default"]],"./Table.css":"cQNEG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kWVt3":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronDown);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const ChevronDown = (0, _createLucideIconJsDefault.default)("chevron-down", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kvLo9":[function(require,module,exports,__globalThis) {
/**
 * @license lucide-react v0.517.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__iconNode", ()=>__iconNode);
parcelHelpers.export(exports, "default", ()=>ChevronUp);
var _createLucideIconJs = require("../createLucideIcon.js");
var _createLucideIconJsDefault = parcelHelpers.interopDefault(_createLucideIconJs);
const __iconNode = [
    [
        "path",
        {
            d: "m18 15-6-6-6 6",
            key: "153udz"
        }
    ]
];
const ChevronUp = (0, _createLucideIconJsDefault.default)("chevron-up", __iconNode);

},{"../createLucideIcon.js":"gsSty","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cQNEG":[function() {},{}],"anhUA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _checkbox = require("vanilla-starter/Checkbox");
var _react = require("react");
"use client";
const rows = [
    {
        name: 'Games',
        date: '6/7/2020',
        type: 'File folder'
    },
    {
        name: 'Program Files',
        date: '4/7/2021',
        type: 'File folder'
    },
    {
        name: 'bootmgr',
        date: '11/20/2010',
        type: 'System file'
    },
    {
        name: 'log.txt',
        date: '1/18/2016',
        type: 'Text Document'
    }
];
function Example() {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    function performBulkAction() {
        selectedKeys;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Table), {
                "aria-label": "Files",
                selectionMode: "multiple",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableHeader), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                    slot: "selection"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                                isRowHeader: true,
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                                children: "Type"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Column), {
                                children: "Date Modified"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.TableBody), {
                        items: rows,
                        children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Row), {
                                id: item.name,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkbox.Checkbox), {
                                            slot: "selection"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                        children: item.name
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                        children: item.type
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                        children: item.date
                                    })
                                ]
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKeys: ",
                    selectedKeys === 'all' ? 'all' : [
                        ...selectedKeys
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","react-aria-components":"3vnUd","vanilla-starter/Checkbox":"eZZAR","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1875w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
var _react = require("react");
"use client";
function Example(props) {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBox), {
        ...props,
        "aria-label": "ListBox",
        selectionMode: "multiple",
        selectedKeys: selectedKeys,
        onSelectionChange: setSelectedKeys,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                id: "one",
                children: "One"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                id: "two",
                children: "Two"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
                id: "three",
                children: "Three"
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8hhel":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
"use client";
function Example(props) {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridList), {
        ...props,
        "aria-label": "GridList",
        selectionMode: "multiple",
        selectedKeys: selectedKeys,
        onSelectionChange: setSelectedKeys,
        "data-size": "small",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
                textValue: "Desert Sunset",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: "https://images.unsplash.com/photo-1705034598432-1694e203cdf3?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                        width: 600,
                        height: 400
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        children: "Desert Sunset"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "description",
                        children: "PNG \u2022 2/3/2024"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
                textValue: "Hiking Trail",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: "https://images.unsplash.com/photo-1722233987129-61dc344db8b6?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                        width: 600,
                        height: 900
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        children: "Hiking Trail"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "description",
                        children: "JPEG \u2022 1/10/2022"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
                textValue: "Lion",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: "https://images.unsplash.com/photo-1629812456605-4a044aa38fbc?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                        width: 600,
                        height: 899
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        children: "Lion"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                        slot: "description",
                        children: "JPEG \u2022 8/28/2021"
                    })
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":"jt9fm","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jzp7j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
var _react = require("react");
"use client";
function Example(props) {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tree.Tree), {
                ...props,
                "aria-label": "Files",
                defaultExpandedKeys: [
                    'documents',
                    'photos',
                    'project'
                ],
                selectionMode: "multiple",
                selectedKeys: selectedKeys,
                onSelectionChange: setSelectedKeys,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                        id: "documents",
                        title: "Documents",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                            id: "project",
                            title: "Project",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                                title: "Weekly Report"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tree.TreeItem), {
                        id: "photos",
                        title: "Photos",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                                title: "Image 1"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                                title: "Image 2"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKeys: ",
                    selectedKeys === 'all' ? 'all' : [
                        ...selectedKeys
                    ].join(', ')
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"l5Eus":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
var _react = require("react");
"use client";
function Example(props) {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
        ...props,
        label: "TagGroup",
        selectionMode: "multiple",
        selectedKeys: selectedKeys,
        onSelectionChange: setSelectedKeys,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                id: "one",
                children: "One"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                id: "two",
                children: "Two"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
                id: "three",
                children: "Three"
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a0VT0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _table = require("vanilla-starter/Table");
var _reactAriaComponents = require("react-aria-components");
var _react = require("react");
"use client";
function Example(props) {
    let [selectedKeys, setSelectedKeys] = (0, _react.useState)(new Set());
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
        ...props,
        "aria-label": "Table",
        selectionMode: "multiple",
        selectedKeys: selectedKeys,
        onSelectionChange: setSelectedKeys,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHeader), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                        isRowHeader: true,
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                        children: "Date Modified"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.TableBody), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "Games"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "File folder"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "6/7/2020"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "Program Files"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "File folder"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "4/7/2021"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "bootmgr"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "System file"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "11/20/2010"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "log.txt"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "Text Document"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Cell), {
                                children: "1/18/2016"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Table":"ja8ai","react-aria-components":"3vnUd","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8ablj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _comboBox = require("vanilla-starter/ComboBox");
var _react = require("react");
"use client";
function Example() {
    let [selectedKey, setSelectedKey] = (0, _react.useState)(null);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _comboBox.ComboBox), {
                label: "ComboBox",
                selectedKey: selectedKey,
                onSelectionChange: setSelectedKey,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBoxItem), {
                        id: "one",
                        children: "One"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBoxItem), {
                        id: "two",
                        children: "Two"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comboBox.ComboBoxItem), {
                        id: "three",
                        children: "Three"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "selectedKey: ",
                    String(selectedKey)
                ]
            })
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)(Example, {});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ComboBox":"bYxIA","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bYxIA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComboBox", ()=>ComboBox);
parcelHelpers.export(exports, "ComboBoxItem", ()=>ComboBoxItem);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _form = require("./Form");
var _listBox = require("./ListBox");
var _popover = require("./Popover");
var _lucideReact = require("lucide-react");
var _comboBoxCss = require("./ComboBox.css");
'use client';
function ComboBox({ label, description, errorMessage, children, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.ComboBox), {
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Label), {
                children: label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "combobox-field",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Input), {
                        className: "react-aria-Input inset"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldButton), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lucideReact.ChevronDown), {
                            size: 16
                        })
                    })
                ]
            }),
            description && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.Description), {
                children: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _form.FieldError), {
                children: errorMessage
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _popover.Popover), {
                hideArrow: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBox), {
                    children: children
                })
            })
        ]
    });
}
function ComboBoxItem(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.DropdownItem), {
        ...props
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["ComboBox","aR9kO"],["Input","jU9y1"]],"./Form":"6qejZ","./ListBox":"kNiGV","./Popover":"cvyKh","lucide-react":[["ChevronDown","kWVt3","default"]],"./ComboBox.css":"hen6Q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cvyKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popover", ()=>Popover);
var _jsxRuntime = require("react/jsx-runtime");
var _reactAriaComponents = require("react-aria-components");
var _clsx = require("clsx");
var _clsxDefault = parcelHelpers.interopDefault(_clsx);
var _popoverCss = require("./Popover.css");
'use client';
function Popover({ children, hideArrow, ...props }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Popover), {
        ...props,
        className: (0, _clsxDefault.default)("react-aria-Popover", props.className),
        children: ({ trigger })=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    !hideArrow && trigger !== 'MenuTrigger' && trigger !== 'SubmenuTrigger' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.OverlayArrow), {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            width: 12,
                            height: 12,
                            viewBox: "0 0 12 12",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M0 0 L6 6 L12 0"
                            })
                        })
                    }),
                    children
                ]
            })
    });
}

},{"react/jsx-runtime":"2Is6Z","react-aria-components":[["OverlayArrow","kMtnS"],["Popover","l4JC0"]],"clsx":"4P1lK","./Popover.css":"6SWas","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"6SWas":[function() {},{}],"hen6Q":[function() {},{}],"jzq0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
var _reactAriaComponents = require("react-aria-components");
var _selectionIndicatorCss = require("./SelectionIndicator.css");
"use client";
function SelectableItem({ id, children }) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBoxItem), {
        id: id,
        className: "animated-ListBoxItem",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.SelectionIndicator), {}),
            children
        ]
    });
}
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBox), {
    "aria-label": "Animated ListBox",
    selectionMode: "single",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectableItem, {
            children: "Home"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectableItem, {
            children: "Getting Started"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)(SelectableItem, {
            children: "Components"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","react-aria-components":"dgQU7","./SelectionIndicator.css":"c26xv","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"c26xv":[function() {},{}],"kxK30":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridList), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            onAction: ()=>alert('Opening "Mountain Sunrise"'),
            textValue: "Mountain Sunrise",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://images.unsplash.com/photo-1722172118908-1a97c312ce8c?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                    width: 600,
                    height: 900
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: "Mountain Sunrise"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: "PNG \u2022 3/15/2015"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            onAction: ()=>alert('Opening "Architecture"'),
            textValue: "Architecture",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://images.unsplash.com/photo-1721661657253-6621d52db753?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHx0b3BpYy1mZWVkfDYxfE04alZiTGJUUndzfHxlbnwwfHx8fHw%3D",
                    width: 600,
                    height: 900
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: "Architecture"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: "PNG \u2022 12/24/2016"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            onAction: ()=>alert('Opening "Golden Hour"'),
            textValue: "Golden Hour",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://images.unsplash.com/photo-1718378037953-ab21bf2cf771?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                    width: 600,
                    height: 402
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: "Golden Hour"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: "WEBP \u2022 7/24/2024"
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7p93m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.Tree), {
    "aria-label": "Files",
    selectionMode: "multiple",
    defaultExpandedKeys: [
        'computer'
    ],
    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tree.TreeItem), {
        id: "computer",
        title: "My Computer",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                title: "Games",
                onAction: ()=>alert('Opening Games')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                title: "Documents",
                onAction: ()=>alert('Opening Documents')
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                title: "Photos",
                onAction: ()=>alert('Opening Photos')
            })
        ]
    })
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"jTgIU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _table = require("vanilla-starter/Table");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
    "aria-label": "Table",
    selectionMode: "multiple",
    selectionMode: "multiple",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHeader), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    isRowHeader: true,
                    children: "Name"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    children: "Type"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    children: "Date Modified"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableBody), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                    onAction: ()=>alert('Opening Games'),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "Games"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "File folder"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "6/7/2020"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                    onAction: ()=>alert('Opening Documents'),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "Documents"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "File folder"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "4/7/2021"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                    onAction: ()=>alert('Opening Photos'),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "Photos"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "File folder"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: "11/20/2010"
                        })
                    ]
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Table":"ja8ai","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"267ze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
"use client";
let images = [
    {
        title: "Rays of sun in the forest",
        user: "Joyce G",
        image: "https://images.unsplash.com/photo-1736185597807-371cae1c7e4e?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNDA4NDh8MHwxfHRvcGljfHw2c01WalRMU2tlUXx8fHx8Mnx8MTczODM2NzE4M3w&ixlib=rb-4.0.3&q=80&w=400",
        width: 400,
        height: 600
    },
    {
        title: "Tall grass",
        user: "Ingmar H",
        image: "https://images.unsplash.com/photo-1737301519296-062cd324dbfa?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNDA4NDh8MHwxfHRvcGljfHw2c01WalRMU2tlUXx8fHx8Mnx8MTczODM2NzE4M3w&ixlib=rb-4.0.3&q=80&w=400",
        width: 400,
        height: 600
    },
    {
        title: "Winding Road",
        user: "Artem Stoliar",
        image: "https://images.unsplash.com/photo-1738249034651-1896f689be58?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wzNDA4NDh8MHwxfHRvcGljfHw2c01WalRMU2tlUXx8fHx8Mnx8MTczODM2NzE4M3w&ixlib=rb-4.0.3&q=80&w=400",
        width: 400,
        height: 300
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
    "aria-label": "Files",
    selectionMode: "multiple",
    "data-size": "small",
    items: images,
    onAction: (id)=>alert(`Opening "${id}"`),
    children: (image)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            id: image.title,
            textValue: image.title,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: image.image,
                    width: image.width,
                    height: image.height
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: image.title
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: [
                        "By ",
                        image.user
                    ]
                })
            ]
        })
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7WKbX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
var _reactAriaComponents = require("react-aria-components");
"use client";
const files = [
    {
        id: 'games',
        name: 'Games'
    },
    {
        id: 'documents',
        name: 'Documents'
    },
    {
        id: 'photos',
        name: 'Photos'
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.Tree), {
    "aria-label": "Files",
    selectionMode: "multiple",
    defaultExpandedKeys: [
        'computer'
    ],
    onAction: (id)=>alert(`Opening ${id}`),
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
        id: "computer",
        title: "My Computer",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
            items: files,
            children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                    title: item.name
                })
        })
    })
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","react-aria-components":"2Jd0Q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1vEL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _table = require("vanilla-starter/Table");
"use client";
const files = [
    {
        id: 'games',
        name: 'Games',
        type: 'Folder',
        date: '6/7/2020'
    },
    {
        id: 'documents',
        name: 'Documents',
        type: 'Folder',
        date: '4/7/2021'
    },
    {
        id: 'photos',
        name: 'Photos',
        type: 'Folder',
        date: '11/20/2010'
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
    "aria-label": "Table",
    selectionMode: "multiple",
    onRowAction: (id)=>alert(`Opening ${id}`),
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHeader), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    isRowHeader: true,
                    children: "Name"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    children: "Type"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    children: "Date Modified"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
            items: files,
            children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: item.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: item.type
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: item.date
                        })
                    ]
                })
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Table":"ja8ai","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"eMQ0g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _listBox.ListBox), {
    "aria-label": "Pokemon",
    selectionMode: "multiple",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
            children: "Charizard"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
            children: "Blastoise"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
            isDisabled: true,
            children: "Venusaur"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
            children: "Pikachu"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hdPnq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridList), {
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            textValue: "Desert Sunset",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://images.unsplash.com/photo-1705034598432-1694e203cdf3?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                    width: 600,
                    height: 400
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: "Desert Sunset"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: "PNG \u2022 2/3/2024"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            isDisabled: true,
            textValue: "Hiking Trail",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://images.unsplash.com/photo-1722233987129-61dc344db8b6?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                    width: 600,
                    height: 900
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: "Hiking Trail"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: "JPEG \u2022 1/10/2022"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            textValue: "Lion",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://images.unsplash.com/photo-1629812456605-4a044aa38fbc?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                    width: 600,
                    height: 899
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: "Lion"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: "JPEG \u2022 8/28/2021"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            textValue: "Mountain Sunrise",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: "https://images.unsplash.com/photo-1722172118908-1a97c312ce8c?q=80&w=600&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
                    width: 600,
                    height: 900
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: "Mountain Sunrise"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    slot: "description",
                    children: "PNG \u2022 3/15/2015"
                })
            ]
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"i08MQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tree.Tree), {
    "aria-label": "Pokemon evolution",
    style: {
        height: 250
    },
    defaultExpandedKeys: [
        'bulbasaur',
        'ivysaur'
    ],
    selectionMode: "multiple",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
            id: "bulbasaur",
            title: "Bulbasaur",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                id: "ivysaur",
                title: "Ivysaur",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                    id: "venusaur",
                    title: "Venusaur",
                    isDisabled: true
                })
            })
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
            id: "charmander",
            title: "Charmander",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                id: "charmeleon",
                title: "Charmeleon",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                    id: "charizard",
                    title: "Charizard"
                })
            })
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
            id: "squirtle",
            title: "Squirtle",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                id: "wartortle",
                title: "Wartortle",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
                    id: "blastoise",
                    title: "Blastoise"
                })
            })
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cWezW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
"use client";
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _tagGroup.TagGroup), {
    label: "Pokemon",
    selectionMode: "multiple",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Charizard"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Blastoise"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            isDisabled: true,
            children: "Venusaur"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: "Pikachu"
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"da5Z5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _listBox = require("vanilla-starter/ListBox");
"use client";
const items = [
    {
        id: 1,
        name: 'Charizard'
    },
    {
        id: 2,
        name: 'Blastoise'
    },
    {
        id: 3,
        name: 'Venusaur'
    },
    {
        id: 4,
        name: 'Pikachu'
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBox), {
    "aria-label": "Pokemon",
    disabledKeys: [
        3
    ],
    selectionMode: "multiple",
    items: items,
    children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listBox.ListBoxItem), {
            children: item.name
        })
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/ListBox":"kNiGV","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1QDFY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _gridList = require("vanilla-starter/GridList");
var _reactAriaComponents = require("react-aria-components");
"use client";
const items = [
    {
        id: 1,
        name: 'Charizard'
    },
    {
        id: 2,
        name: 'Blastoise'
    },
    {
        id: 3,
        name: 'Venusaur'
    },
    {
        id: 4,
        name: 'Pikachu'
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _gridList.GridList), {
    "aria-label": "Pokemon",
    "data-size": "small",
    disabledKeys: [
        3
    ],
    items: items,
    children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _gridList.GridListItem), {
            textValue: item.name,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: `https://img.pokemondb.net/sprites/home/normal/2x/avif/${item.name.toLowerCase()}.avif`
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Text), {
                    children: item.name
                })
            ]
        })
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/GridList":"hvGD4","react-aria-components":"jt9fm","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"dU7kA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tree = require("vanilla-starter/Tree");
var _reactAriaComponents = require("react-aria-components");
"use client";
let items = [
    {
        id: 1,
        name: 'Bulbasaur',
        type: 'Grass',
        level: 14,
        children: [
            {
                id: 2,
                name: 'Ivysaur',
                type: 'Grass',
                level: 30,
                children: [
                    {
                        id: 3,
                        name: 'Venusaur',
                        type: 'Grass',
                        level: 83
                    }
                ]
            }
        ]
    },
    {
        id: 4,
        name: 'Charmander',
        type: 'Fire',
        level: 16,
        children: [
            {
                id: 5,
                name: 'Charmeleon',
                type: 'Fire',
                level: 32,
                children: [
                    {
                        id: 6,
                        name: 'Charizard',
                        type: 'Fire, Flying',
                        level: 67
                    }
                ]
            }
        ]
    },
    {
        id: 7,
        name: 'Squirtle',
        type: 'Water',
        level: 8,
        children: [
            {
                id: 8,
                name: 'Wartortle',
                type: 'Water',
                level: 34,
                children: [
                    {
                        id: 9,
                        name: 'Blastoise',
                        type: 'Water',
                        level: 56
                    }
                ]
            }
        ]
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.Tree), {
    "aria-label": "Pokemon evolution",
    style: {
        height: 250
    },
    defaultExpandedKeys: [
        1,
        2
    ],
    selectionMode: "multiple",
    disabledKeys: [
        3
    ],
    items: items,
    children: function renderItem(item) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tree.TreeItem), {
            title: item.name,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaComponents.Collection), {
                items: item.children,
                children: renderItem
            })
        });
    }
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Tree":"ifc8k","react-aria-components":"2Jd0Q","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"9AQWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _tagGroup = require("vanilla-starter/TagGroup");
"use client";
const items = [
    {
        id: 1,
        name: 'Charizard'
    },
    {
        id: 2,
        name: 'Blastoise'
    },
    {
        id: 3,
        name: 'Venusaur'
    },
    {
        id: 4,
        name: 'Pikachu'
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.TagGroup), {
    "aria-label": "Pokemon",
    selectionMode: "multiple",
    disabledKeys: [
        3
    ],
    items: items,
    children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tagGroup.Tag), {
            children: item.name
        })
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/TagGroup":"eq0FG","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"gMwjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _table = require("vanilla-starter/Table");
"use client";
let items = [
    {
        id: 1,
        name: 'Charizard',
        type: 'Fire, Flying',
        level: 67
    },
    {
        id: 2,
        name: 'Blastoise',
        type: 'Water',
        level: 56
    },
    {
        id: 3,
        name: 'Venusaur',
        type: 'Grass, Poison',
        level: 83
    },
    {
        id: 4,
        name: 'Pikachu',
        type: 'Electric',
        level: 100
    }
];
exports.default = /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Table), {
    "aria-label": "Pokemon",
    disabledKeys: [
        3
    ],
    selectionMode: "multiple",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.TableHeader), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    isRowHeader: true,
                    children: "Name"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    children: "Type"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Column), {
                    children: "Level"
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.TableBody), {
            items: items,
            children: (item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _table.Row), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: item.name
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: item.type
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _table.Cell), {
                            children: item.level
                        })
                    ]
                })
        })
    ]
});

},{"react/jsx-runtime":"2Is6Z","vanilla-starter/Table":"ja8ai","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"a5H2j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLibraryFromUrl", ()=>getLibraryFromUrl);
parcelHelpers.export(exports, "getLibraryFromPage", ()=>getLibraryFromPage);
parcelHelpers.export(exports, "getLibraryLabel", ()=>getLibraryLabel);
parcelHelpers.export(exports, "getLibraryIcon", ()=>getLibraryIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _internationalizedLogo = require("./icons/InternationalizedLogo");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactAriaLogo = require("./icons/ReactAriaLogo");
function getLibraryFromUrl(url) {
    if (url.includes('/react-aria/')) return 'react-aria';
    if (url.includes('/internationalized/')) return 'internationalized';
    if (url.includes('/s2/')) return 'react-spectrum';
    return 'react-spectrum';
}
function getLibraryFromPage(page) {
    return getLibraryFromUrl(page.url);
}
function getLibraryLabel(library) {
    switch(library){
        case 'react-aria':
            return 'React Aria';
        case 'internationalized':
            return 'Internationalized';
        default:
            return 'React Spectrum';
    }
}
function getLibraryIcon(library) {
    switch(library){
        case 'react-aria':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {});
        case 'internationalized':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internationalizedLogo.InternationalizedLogo), {});
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {});
    }
}

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/InternationalizedLogo":"ge2ja","react":"a1TxN","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"5Bj5G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdobeLogo", ()=>AdobeLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AdobeLogo = ({ className = '', size = 32 })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: className,
        style: {
            width: size,
            height: size
        },
        xmlns: "http://www.w3.org/2000/svg",
        "data-name": "Layer 2",
        viewBox: "0 0 501.71 444.05",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "m297.58 444.05-36.45-101.4h-91.46l76.87-193.53 116.65 294.93h138.52L316.8 0H186.23L0 444.05h297.58z",
            "data-name": "Layer 1",
            className: " t4u0Crc12 _Va12"
        })
    });
};

},{"0":"7PUbU","react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"7PUbU":[function() {},{}],"ge2ja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InternationalizedLogo", ()=>InternationalizedLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const InternationalizedLogo = ({ size = 32 })=>{
    const clipPathId = `internationalized-logo-clip-${(0, _react.useId)()}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        id: "Layer_1",
        viewBox: "15 17 135 128",
        style: {
            width: size,
            height: size
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: clipPathId,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.98 79.99c0-17.01 7.58-32.25 19.54-42.52.92 2.02 2.32 4.67 4 7.13 1.05 1.54 2.28 3.1 3.65 4.41 1.33 1.27 3.04 2.55 5.08 3.13 3.29.94 7.1.8 9.98.7l.88-.03c1.63-.05 2.94-.07 4.03.05 1.11.11 1.57.33 1.71.42.31.2.39.37.41.43.03.08.07.22.03.46-.09.52-.53 1.28-1.4 1.76-2.07 1.15-4.14 2.6-5.69 4.59-1.63 2.09-2.54 4.6-2.54 7.55 0 .86-.07 1.4-.15 1.72v.03c-.28.06-.81.1-1.7.03-.27-.02-.55-.05-.86-.07-2.32-.21-5.69-.5-8.87-.17-3.54.37-8.1 1.64-10.56 5.96-1.08 1.89-2.33 5.04-2.03 8.8.31 3.92 2.27 7.99 6.71 11.55 5.12 4.1 10.75 4.98 18.12 5.8 4.2.47 6.58 1.37 7.94 2.33 1.19.84 1.85 1.9 2.18 3.55.58 2.88-.4 7.19-2.43 12.45-.97 2.52-2.11 5.05-3.24 7.52-.25.54-.5 1.08-.74 1.61-.81 1.76-1.61 3.47-2.27 5.03C41.73 127.9 24 106.03 24 80.02Zm26.36-46.91c-.07-.17-.15-.33-.24-.49a55.64 55.64 0 0 1 12.37-5.84c.05.3.14.6.26.89 2.06 4.9 8.3 10.94 16.68 10.94 4.33 0 7.8-1.86 10.35-3.97 2.53-2.1 4.34-4.6 5.47-6.33.41-.63.62-1.34.65-2.04.69.2 1.37.42 2.05.65-.06.18-.1.37-.13.57-.67 4.46-1.44 10.7-.74 16.34.69 5.54 3.01 11.91 9.76 14.25 5.36 1.86 10.66.94 14.8-.9 2.74-1.22 5.23-2.96 7.07-4.9 2.11 3.7 3.81 7.65 5.04 11.81l-1.75-.36c-3.01-.59-7.06-1.26-11.28-1.54-4.16-.28-8.77-.19-12.78.91-4.02 1.1-8.1 3.44-9.84 8.13-4.86 13.11 1.7 21.06 3.39 22.75 2.55 2.55 5.17 3.75 7.1 4.62.23.11.46.21.67.31 1.86.87 3.19 1.63 4.54 3.58.47.67.94 1.89 1.3 3.74.34 1.8.52 3.89.58 6.11.07 2.2.02 4.41-.04 6.43l-.06 1.63c-.04 1.08-.07 2.1-.09 2.95a55.775 55.775 0 0 1-35.48 12.67c-2.09 0-4.15-.11-6.18-.34.44-.97.91-1.99 1.41-3.08.26-.55.52-1.12.79-1.71 1.15-2.49 2.37-5.21 3.44-7.97 2.05-5.28 3.89-11.54 2.82-16.9-.67-3.35-2.3-6.32-5.41-8.51-2.94-2.07-6.85-3.21-11.67-3.74-7.46-.83-10.89-1.6-14.01-4.09-2.9-2.32-3.62-4.43-3.74-5.93-.13-1.67.44-3.21 1-4.2.51-.9 1.72-1.68 4.44-1.97 2.35-.25 4.9-.03 7.3.18.31.03.62.05.93.08 2.86.24 5.98-.1 8.18-2.42 2.06-2.18 2.33-5.13 2.33-7.33 0-1.17.32-1.95.86-2.64.61-.79 1.63-1.6 3.26-2.51 2.83-1.57 4.87-4.32 5.4-7.4.56-3.26-.64-6.73-3.89-8.9-1.72-1.14-3.68-1.55-5.33-1.72-1.68-.17-3.48-.13-5.1-.08-.22 0-.44.01-.65.02-3.22.11-5.75.19-7.75-.38-.27-.08-.86-.38-1.74-1.22-.84-.8-1.72-1.89-2.58-3.15-1.73-2.53-3.12-5.37-3.79-7Zm73.36 81.97a55.79 55.79 0 0 0 12.32-35.06c0-2.49-.16-4.94-.48-7.34-.05 0-.09-.02-.12-.02-.14-.03-.29-.06-.42-.09-.2-.04-.45-.1-.74-.16l-.35-.08c-.87-.2-2.06-.46-3.47-.73-2.84-.56-6.52-1.16-10.27-1.41-3.81-.25-7.38-.11-10.13.64-2.73.75-3.97 1.89-4.45 3.2-3.38 9.13 1.14 13.91 1.55 14.32 1.49 1.49 2.84 2.11 4.77 3 .23.11.47.22.73.34 2.42 1.13 5.22 2.64 7.73 6.27 1.39 2 2.14 4.47 2.58 6.79.46 2.38.65 4.94.72 7.37.03 1 .04 1.99.03 2.96Zm.28-69.78a56.276 56.276 0 0 0-18.47-15.18c-.57 4.1-.99 8.75-.5 12.73.56 4.56 2.1 6.86 4.44 7.68 2.96 1.03 6.11.6 8.92-.65 2.91-1.3 4.85-3.21 5.46-4.32.05-.09.1-.18.16-.26ZM80 23.96c2.75 0 5.46.2 8.11.58-.9 1.31-2.06 2.75-3.46 3.91-1.61 1.33-3.33 2.13-5.24 2.13-4.39 0-7.99-3.27-9.19-5.78 3.17-.56 6.44-.85 9.78-.85Z",
                            className: "st0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: `${clipPathId}-1`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.98 80c0-17.01 7.58-32.25 19.54-42.52.92 2.02 2.32 4.67 4 7.13 1.05 1.54 2.28 3.1 3.65 4.41 1.33 1.27 3.04 2.55 5.08 3.13 3.29.94 7.1.8 9.98.7l.88-.03c1.63-.05 2.94-.07 4.03.05 1.11.11 1.57.33 1.71.42.31.2.39.37.41.43.03.08.07.22.03.46-.09.52-.53 1.28-1.4 1.76-2.07 1.15-4.14 2.6-5.69 4.59-1.63 2.09-2.54 4.6-2.54 7.55 0 .86-.07 1.4-.15 1.72v.03c-.28.06-.81.1-1.7.03-.27-.02-.55-.05-.86-.07-2.32-.21-5.69-.5-8.87-.17-3.54.37-8.1 1.64-10.56 5.96-1.08 1.89-2.33 5.04-2.03 8.8.31 3.92 2.27 7.99 6.71 11.55 5.12 4.1 10.75 4.98 18.12 5.8 4.2.47 6.58 1.37 7.94 2.33 1.19.84 1.85 1.9 2.18 3.55.58 2.88-.4 7.19-2.43 12.45-.97 2.52-2.11 5.05-3.24 7.52-.25.54-.5 1.08-.74 1.61-.81 1.76-1.61 3.47-2.27 5.03C41.73 127.91 24 106.04 24 80.03Zm99.72 35.06A55.79 55.79 0 0 0 136.02 80c0-2.49-.16-4.94-.48-7.34-.05 0-.09-.02-.12-.02-.14-.03-.29-.06-.42-.09-.2-.04-.45-.1-.74-.16l-.35-.08c-.87-.2-2.06-.46-3.47-.73-2.84-.56-6.52-1.16-10.27-1.41-3.81-.25-7.38-.11-10.13.64-2.73.75-3.97 1.89-4.45 3.2-3.38 9.13 1.14 13.91 1.55 14.32 1.49 1.49 2.84 2.11 4.77 3 .23.11.47.22.73.34 2.42 1.13 5.22 2.64 7.73 6.27 1.39 2 2.14 4.47 2.58 6.79.46 2.38.65 4.94.72 7.37.03 1 .04 1.99.03 2.96Zm.28-69.77a56.276 56.276 0 0 0-18.47-15.18c-.57 4.1-.99 8.75-.5 12.73.56 4.56 2.1 6.86 4.44 7.68 2.96 1.03 6.11.6 8.92-.65 2.91-1.3 4.85-3.21 5.46-4.32.05-.09.1-.18.16-.26ZM80 23.98c2.75 0 5.46.2 8.11.58-.9 1.31-2.06 2.75-3.46 3.91-1.61 1.33-3.33 2.13-5.24 2.13-4.39 0-7.99-3.27-9.19-5.78 3.17-.56 6.44-.85 9.78-.85Z",
                            className: "st0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                        children: '.st0{fill:none}'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: `url(#${clipPathId})`
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15 17h135v128H15z",
                    style: {
                        fill: '#6995fe'
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: `url(#${clipPathId}-1)`
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15 17.01h135v128H15z",
                    style: {
                        fill: '#099d59'
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"iQPne":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactAriaLogo", ()=>ReactAriaLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ReactAriaLogo = ({ size = 32 })=>{
    const clipPathId = `react-aria-logo-clip-${(0, _react.useId)()}`;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "15.79 17.64 131.21 126.14",
        style: {
            width: size,
            height: size
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: clipPathId,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M80 136c30.93 0 56-25.07 56-56s-25.07-56-56-56-56 25.07-56 56 25.07 56 56 56Zm8.48-86.3c0 4.69-3.8 8.48-8.48 8.48s-8.48-3.8-8.48-8.48 3.8-8.48 8.48-8.48 8.48 3.8 8.48 8.48ZM51.09 61.78c.52-1.8 2.39-2.85 4.2-2.33a89.865 89.865 0 0 0 48.82.17l.64-.18c1.81-.5 3.68.55 4.18 2.36a3.39 3.39 0 0 1-2.36 4.18l-.64.18a97.139 97.139 0 0 1-15.51 2.98c-1.03.11-1.82.97-1.82 2.01v14.89c0 .18.03.37.08.55 1.37 4.83 2.94 10.39 4.32 15.27.98 3.46 1.86 6.58 2.49 8.85.32 1.14.58 2.06.76 2.71l.04.15c.13.48.27.97.31 1.16a3.38 3.38 0 0 1-2.66 3.99 3.38 3.38 0 0 1-3.99-2.66c.02.09 0 .04-.08-.27-.04-.13-.09-.31-.15-.54-.18-.65-.44-1.57-.76-2.7-.64-2.27-1.52-5.39-2.49-8.85l-3.74-13.21a1.992 1.992 0 0 0-1.92-1.45h-1.6c-.89 0-1.68.59-1.92 1.45-1.22 4.3-2.55 9.01-3.74 13.21-.98 3.46-1.85 6.58-2.49 8.85-.32 1.13-.58 2.06-.76 2.7-.06.23-.11.41-.15.54-.09.31-.1.36-.08.27a3.39 3.39 0 1 1-6.65-1.33c.04-.18.18-.68.31-1.16l.04-.15c.18-.65.44-1.58.76-2.71.64-2.27 1.52-5.39 2.49-8.85 1.38-4.88 2.95-10.44 4.32-15.27.05-.18.08-.36.08-.55V71.16c0-1.04-.79-1.9-1.82-2.01a96.504 96.504 0 0 1-16.17-3.17 3.395 3.395 0 0 1-2.33-4.2Z",
                        style: {
                            fill: 'none'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 80,
                cy: 80,
                r: 50.83,
                style: {
                    fill: '#fff'
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                style: {
                    clipPath: `url(#${clipPathId})`
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M15.79 17.64H147v126.14H15.79z",
                    style: {
                        fill: '#269ff4'
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"2Is6Z","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hYP4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TAB_DEFS", ()=>TAB_DEFS);
var _jsxRuntime = require("react/jsx-runtime");
var _adobeLogo = require("./icons/AdobeLogo");
var _internationalizedLogo = require("./icons/InternationalizedLogo");
var _reactAriaLogo = require("./icons/ReactAriaLogo");
const TAB_DEFS = {
    'react-spectrum': {
        label: 'React Spectrum',
        description: "Components for Adobe's Spectrum design system",
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _adobeLogo.AdobeLogo), {})
    },
    'react-aria': {
        label: 'React Aria',
        description: 'Style-free components and hooks for building accessible UIs',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactAriaLogo.ReactAriaLogo), {})
    },
    'internationalized': {
        label: 'Internationalized',
        description: 'Framework-agnostic internationalization utilities',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _internationalizedLogo.InternationalizedLogo), {})
    }
};

},{"react/jsx-runtime":"2Is6Z","./icons/AdobeLogo":"5Bj5G","./icons/InternationalizedLogo":"ge2ja","./icons/ReactAriaLogo":"iQPne","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"cSREm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "m18.53 17.47-5.083-5.084C14.417 11.186 15 9.66 15 8c0-3.86-3.14-7-7-7S1 4.14 1 8s3.14 7 7 7c1.66 0 3.185-.584 4.386-1.553l5.084 5.083c.146.147.338.22.53.22s.384-.073.53-.22c.293-.293.293-.767 0-1.06M8 13.5c-3.032 0-5.5-2.468-5.5-5.5S4.968 2.5 8 2.5s5.5 2.468 5.5 5.5-2.468 5.5-5.5 5.5"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"2370J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M13 2.5H7c-.414 0-.75-.336-.75-.75S6.586 1 7 1h6c.414 0 .75.336.75.75s-.336.75-.75.75M16.773 14.48q-.022-.046-.05-.09L12.49 7.78V5.493h.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.25c-.414 0-.75.336-.75.75V8c0 .144.041.284.119.404l1.171 1.83-5.686 1.743 2.279-3.574c.076-.12.117-.26.117-.403V4.743c0-.414-.336-.75-.75-.75H6.99c-.414 0-.75.336-.75.75s.336.75.75.75h.5v2.288l-4.213 6.61q-.028.043-.049.09c-.351.761-.29 1.638.164 2.346C3.86 17.562 4.67 18 5.558 18h8.884c.887 0 1.697-.438 2.167-1.173.453-.708.515-1.585.164-2.347m-1.427 1.539c-.193.301-.531.481-.904.481H5.558c-.373 0-.71-.18-.904-.481-.171-.268-.2-.582-.082-.87l.779-1.222 7.768-2.383 2.31 3.604c.117.29.088.604-.083.87"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"kmqkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M7.75 16.465c-.187 0-.374-.07-.52-.21-.298-.287-.308-.762-.02-1.06l4.999-5.197-4.986-5.184c-.288-.297-.279-.772.02-1.06.296-.286.774-.278 1.06.021L13.79 9.48c.28.29.28.749 0 1.039l-5.5 5.716c-.146.154-.344.23-.54.23"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"bneuv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _icon = require("~/src/Icon");
var _react = require("react");
const SvgComponent = (props, ref)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "var(--iconPrimary, var(--lightningcss-light, rgb(41, 41, 41)) var(--lightningcss-dark, rgb(219, 219, 219)))",
            d: "M16.25 14H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75M3.75 5.5h12.5c.414 0 .75-.336.75-.75S16.664 4 16.25 4H3.75c-.414 0-.75.336-.75.75s.336.75.75.75M16.25 9H3.75c-.414 0-.75.336-.75.75s.336.75.75.75h12.5c.414 0 .75-.336.75-.75S16.664 9 16.25 9"
        })
    });
const ForwardRef = /*#__PURE__*/ (0, _react.forwardRef)(SvgComponent);
exports.default = /*#__PURE__*/ (0, _icon.createIcon)(ForwardRef);

},{"react/jsx-runtime":"2Is6Z","~/src/Icon":"jQAJE","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"1PPGS":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a list component with interactive children.
 * A grid list displays data in a single column and enables a user to navigate its contents via directional navigation keys.
 * @param props - Props for the list.
 * @param state - State for the list, as returned by `useListState`.
 * @param ref - The ref attached to the list element.
 */ parcelHelpers.export(exports, "useGridList", ()=>useGridList);
var _utils = require("@react-aria/utils");
var _utils1 = require("./utils");
var _grid = require("@react-aria/grid");
var _focus = require("@react-aria/focus");
var _selection = require("@react-aria/selection");
function useGridList(props, state, ref) {
    let { isVirtualized, keyboardDelegate, layoutDelegate, onAction, disallowTypeAhead, linkBehavior = 'action', keyboardNavigationBehavior = 'arrow', escapeKeyBehavior = 'clearSelection', shouldSelectOnPressUp } = props;
    if (!props['aria-label'] && !props['aria-labelledby']) console.warn('An aria-label or aria-labelledby prop is required for accessibility.');
    let { listProps } = (0, _selection.useSelectableList)({
        selectionManager: state.selectionManager,
        collection: state.collection,
        disabledKeys: state.disabledKeys,
        ref,
        keyboardDelegate,
        layoutDelegate,
        isVirtualized,
        selectOnFocus: state.selectionManager.selectionBehavior === 'replace',
        shouldFocusWrap: props.shouldFocusWrap,
        linkBehavior,
        disallowTypeAhead,
        autoFocus: props.autoFocus,
        escapeKeyBehavior
    });
    let id = (0, _utils.useId)(props.id);
    (0, _utils1.listMap).set(state, {
        id,
        onAction,
        linkBehavior,
        keyboardNavigationBehavior,
        shouldSelectOnPressUp
    });
    let descriptionProps = (0, _grid.useHighlightSelectionDescription)({
        selectionManager: state.selectionManager,
        hasItemActions: !!onAction
    });
    let hasTabbableChild = (0, _focus.useHasTabbableChild)(ref, {
        isDisabled: state.collection.size !== 0
    });
    let domProps = (0, _utils.filterDOMProps)(props, {
        labelable: true
    });
    let gridProps = (0, _utils.mergeProps)(domProps, {
        role: 'grid',
        id,
        'aria-multiselectable': state.selectionManager.selectionMode === 'multiple' ? 'true' : undefined
    }, // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    state.collection.size === 0 ? {
        tabIndex: hasTabbableChild ? -1 : 0
    } : listProps, descriptionProps);
    if (isVirtualized) {
        gridProps['aria-rowcount'] = state.collection.size;
        gridProps['aria-colcount'] = 1;
    }
    (0, _grid.useGridSelectionAnnouncement)({}, state);
    return {
        gridProps
    };
}

},{"@react-aria/utils":[["filterDOMProps","3upVm"],["mergeProps","aNvcY"],["useId","jbI4Y"]],"./utils":"aJkqW","@react-aria/grid":[["useGridSelectionAnnouncement","deyzk"],["useHighlightSelectionDescription","eO4Xt"]],"@react-aria/focus":"eSQu0","@react-aria/selection":"ldksp","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"aJkqW":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "listMap", ()=>listMap);
parcelHelpers.export(exports, "getRowId", ()=>getRowId);
parcelHelpers.export(exports, "normalizeKey", ()=>normalizeKey);
const listMap = new WeakMap();
function getRowId(state, key) {
    let { id } = listMap.get(state) ?? {};
    if (!id) throw new Error('Unknown list');
    return `${id}-${normalizeKey(key)}`;
}
function normalizeKey(key) {
    if (typeof key === 'string') return key.replace(/\s*/g, '');
    return '' + key;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"deyzk":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGridSelectionAnnouncement", ()=>useGridSelectionAnnouncement);
var _liveAnnouncer = require("@react-aria/live-announcer");
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useGridSelectionAnnouncement(props, state) {
    let { getRowText = (key)=>state.collection.getTextValue?.(key) ?? state.collection.getItem(key)?.textValue } = props;
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    // Many screen readers do not announce when items in a grid are selected/deselected.
    // We do this using an ARIA live region.
    let selection = state.selectionManager.rawSelection;
    let lastSelection = (0, _react.useRef)(selection);
    let announceSelectionChange = (0, _utils.useEffectEvent)(()=>{
        if (!state.selectionManager.isFocused || selection === lastSelection.current) {
            lastSelection.current = selection;
            return;
        }
        let addedKeys = diffSelection(selection, lastSelection.current);
        let removedKeys = diffSelection(lastSelection.current, selection);
        // If adding or removing a single row from the selection, announce the name of that item.
        let isReplace = state.selectionManager.selectionBehavior === 'replace';
        let messages = [];
        if (state.selectionManager.selectedKeys.size === 1 && isReplace) {
            let firstKey = state.selectionManager.selectedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let currentSelectionText = getRowText(firstKey);
                if (currentSelectionText) messages.push(stringFormatter.format('selectedItem', {
                    item: currentSelectionText
                }));
            }
        } else if (addedKeys.size === 1 && removedKeys.size === 0) {
            let firstKey = addedKeys.keys().next().value;
            if (firstKey != null) {
                let addedText = getRowText(firstKey);
                if (addedText) messages.push(stringFormatter.format('selectedItem', {
                    item: addedText
                }));
            }
        } else if (removedKeys.size === 1 && addedKeys.size === 0) {
            let firstKey = removedKeys.keys().next().value;
            if (firstKey != null && state.collection.getItem(firstKey)) {
                let removedText = getRowText(firstKey);
                if (removedText) messages.push(stringFormatter.format('deselectedItem', {
                    item: removedText
                }));
            }
        }
        // Announce how many items are selected, except when selecting the first item.
        if (state.selectionManager.selectionMode === 'multiple') {
            if (messages.length === 0 || selection === 'all' || selection.size > 1 || lastSelection.current === 'all' || lastSelection.current?.size > 1) messages.push(selection === 'all' ? stringFormatter.format('selectedAll') : stringFormatter.format('selectedCount', {
                count: selection.size
            }));
        }
        if (messages.length > 0) (0, _liveAnnouncer.announce)(messages.join(' '));
        lastSelection.current = selection;
    });
    (0, _utils.useUpdateEffect)(()=>{
        if (state.selectionManager.isFocused) announceSelectionChange();
        else {
            // Wait a frame in case the collection is about to become focused (e.g. on mouse down).
            let raf = requestAnimationFrame(announceSelectionChange);
            return ()=>cancelAnimationFrame(raf);
        }
    }, [
        selection,
        state.selectionManager.isFocused
    ]);
}
function diffSelection(a, b) {
    let res = new Set();
    if (a === 'all' || b === 'all') return res;
    for (let key of a.keys())if (!b.has(key)) res.add(key);
    return res;
}

},{"@react-aria/live-announcer":"3nbSW","../intl/*.json":"hdtsN","@react-aria/utils":[["useEffectEvent","eg4dC"],["useUpdateEffect","ekc37"]],"@react-aria/i18n":"7lxyl","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hdtsN":[function(require,module,exports,__globalThis) {
const _temp0 = require("549f76802fea3145");
const _temp1 = require("99e711b09beafbae");
const _temp2 = require("d822d49a9f50f8f2");
const _temp3 = require("62716c14c7ab3b19");
const _temp4 = require("f993c3bd895f4a55");
const _temp5 = require("87ba517e0d2284cb");
const _temp6 = require("9959e6866268baa2");
const _temp7 = require("a5d29cf49321ccbd");
const _temp8 = require("d4a263166a379f7");
const _temp9 = require("adb7cef23c3e7915");
const _temp10 = require("b85e649d4f0c8fa0");
const _temp11 = require("669dff92f11c15b2");
const _temp12 = require("56a3bfdc95a3af99");
const _temp13 = require("92bd2be1c2e45a26");
const _temp14 = require("ac7b779e60091ebf");
const _temp15 = require("7350c7eb30e615e3");
const _temp16 = require("3260bfccae03c79c");
const _temp17 = require("e01abdb08e203859");
const _temp18 = require("5551bd334b751799");
const _temp19 = require("a555cf93e0917ba2");
const _temp20 = require("f519d273a2594a58");
const _temp21 = require("2ab2dc559350f8cb");
const _temp22 = require("aa7f9e578044416a");
const _temp23 = require("7828f13f1de12a9c");
const _temp24 = require("b776cb1c3588783c");
const _temp25 = require("b2c037c8f99b4b1d");
const _temp26 = require("3656d7d096e21208");
const _temp27 = require("64de068ffd5db517");
const _temp28 = require("6afb03c6be24a7db");
const _temp29 = require("fac4d0e10b154d11");
const _temp30 = require("5207f24182fa30c9");
const _temp31 = require("6c177c75c6c9f015");
const _temp32 = require("1c95bec940ff1fe8");
const _temp33 = require("736ec483e330f374");
module.exports = {
    "ar-AE": _temp0,
    "bg-BG": _temp1,
    "cs-CZ": _temp2,
    "da-DK": _temp3,
    "de-DE": _temp4,
    "el-GR": _temp5,
    "en-US": _temp6,
    "es-ES": _temp7,
    "et-EE": _temp8,
    "fi-FI": _temp9,
    "fr-FR": _temp10,
    "he-IL": _temp11,
    "hr-HR": _temp12,
    "hu-HU": _temp13,
    "it-IT": _temp14,
    "ja-JP": _temp15,
    "ko-KR": _temp16,
    "lt-LT": _temp17,
    "lv-LV": _temp18,
    "nb-NO": _temp19,
    "nl-NL": _temp20,
    "pl-PL": _temp21,
    "pt-BR": _temp22,
    "pt-PT": _temp23,
    "ro-RO": _temp24,
    "ru-RU": _temp25,
    "sk-SK": _temp26,
    "sl-SI": _temp27,
    "sr-SP": _temp28,
    "sv-SE": _temp29,
    "tr-TR": _temp30,
    "uk-UA": _temp31,
    "zh-CN": _temp32,
    "zh-TW": _temp33
};

},{"549f76802fea3145":"ctpKo","99e711b09beafbae":"ctpKo","d822d49a9f50f8f2":"ctpKo","62716c14c7ab3b19":"ctpKo","f993c3bd895f4a55":"ctpKo","87ba517e0d2284cb":"ctpKo","9959e6866268baa2":"3Tpgz","a5d29cf49321ccbd":"ctpKo","d4a263166a379f7":"ctpKo","adb7cef23c3e7915":"ctpKo","b85e649d4f0c8fa0":"ctpKo","669dff92f11c15b2":"ctpKo","56a3bfdc95a3af99":"ctpKo","92bd2be1c2e45a26":"ctpKo","ac7b779e60091ebf":"ctpKo","7350c7eb30e615e3":"ctpKo","3260bfccae03c79c":"ctpKo","e01abdb08e203859":"ctpKo","5551bd334b751799":"ctpKo","a555cf93e0917ba2":"ctpKo","f519d273a2594a58":"ctpKo","2ab2dc559350f8cb":"ctpKo","aa7f9e578044416a":"ctpKo","7828f13f1de12a9c":"ctpKo","b776cb1c3588783c":"ctpKo","b2c037c8f99b4b1d":"ctpKo","3656d7d096e21208":"ctpKo","64de068ffd5db517":"ctpKo","6afb03c6be24a7db":"ctpKo","fac4d0e10b154d11":"ctpKo","5207f24182fa30c9":"ctpKo","6c177c75c6c9f015":"ctpKo","1c95bec940ff1fe8":"ctpKo","736ec483e330f374":"ctpKo"}],"3Tpgz":[function(require,module,exports,__globalThis) {
module.exports = {
    "deselectedItem": (args)=>`${args.item} not selected.`,
    "select": `Select`,
    "selectedCount": (args, formatter)=>`${formatter.plural(args.count, {
            "=0": `No items selected`,
            one: ()=>`${formatter.number(args.count)} item selected`,
            other: ()=>`${formatter.number(args.count)} items selected`
        })}.`,
    "selectedAll": `All items selected.`,
    "selectedItem": (args)=>`${args.item} selected.`,
    "longPressToSelect": `Long press to enter selection mode.`
};

},{}],"eO4Xt":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Computes the description for a grid selectable collection.
 * @param props
 */ parcelHelpers.export(exports, "useHighlightSelectionDescription", ()=>useHighlightSelectionDescription);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _interactions = require("@react-aria/interactions");
var _i18N = require("@react-aria/i18n");
var _react = require("react");
function useHighlightSelectionDescription(props) {
    let stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    let modality = (0, _interactions.useInteractionModality)();
    // null is the default if the user hasn't interacted with the table at all yet or the rest of the page
    let shouldLongPress = (modality === 'pointer' || modality === 'virtual' || modality == null) && typeof window !== 'undefined' && 'ontouchstart' in window;
    let interactionDescription = (0, _react.useMemo)(()=>{
        let selectionMode = props.selectionManager.selectionMode;
        let selectionBehavior = props.selectionManager.selectionBehavior;
        let message;
        if (shouldLongPress) message = stringFormatter.format('longPressToSelect');
        return selectionBehavior === 'replace' && selectionMode !== 'none' && props.hasItemActions ? message : undefined;
    }, [
        props.selectionManager.selectionMode,
        props.selectionManager.selectionBehavior,
        props.hasItemActions,
        stringFormatter,
        shouldLongPress
    ]);
    let descriptionProps = (0, _utils.useDescription)(interactionDescription);
    return descriptionProps;
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"h4qnk","@react-aria/interactions":"dkfxW","@react-aria/i18n":"7lxyl","react":"a1TxN","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"fNHH4":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a row in a grid list.
 * @param props - Props for the row.
 * @param state - State of the parent list, as returned by `useListState`.
 * @param ref - The ref attached to the row element.
 */ parcelHelpers.export(exports, "useGridListItem", ()=>useGridListItem);
var _utils = require("@react-aria/utils");
var _focus = require("@react-aria/focus");
var _utils1 = require("./utils");
var _react = require("react");
var _interactions = require("@react-aria/interactions");
var _selection = require("@react-aria/selection");
var _i18N = require("@react-aria/i18n");
const EXPANSION_KEYS = {
    'expand': {
        ltr: 'ArrowRight',
        rtl: 'ArrowLeft'
    },
    'collapse': {
        ltr: 'ArrowLeft',
        rtl: 'ArrowRight'
    }
};
function useGridListItem(props, state, ref) {
    // Copied from useGridCell + some modifications to make it not so grid specific
    let { node, isVirtualized } = props;
    // let stringFormatter = useLocalizedStringFormatter(intlMessages, '@react-aria/gridlist');
    let { direction } = (0, _i18N.useLocale)();
    let { onAction, linkBehavior, keyboardNavigationBehavior, shouldSelectOnPressUp } = (0, _utils1.listMap).get(state);
    let descriptionId = (0, _utils.useSlotId)();
    // We need to track the key of the item at the time it was last focused so that we force
    // focus to go to the item when the DOM node is reused for a different item in a virtualizer.
    let keyWhenFocused = (0, _react.useRef)(null);
    let focus = ()=>{
        // Don't shift focus to the row if the active element is a element within the row already
        // (e.g. clicking on a row button)
        if (ref.current !== null && (keyWhenFocused.current != null && node.key !== keyWhenFocused.current || !ref.current?.contains(document.activeElement))) (0, _focus.focusSafely)(ref.current);
    };
    let treeGridRowProps = {};
    let hasChildRows = props.hasChildItems;
    let hasLink = state.selectionManager.isLink(node.key);
    if (node != null && 'expandedKeys' in state) {
        // TODO: ideally node.hasChildNodes would be a way to tell if a row has child nodes, but the row's contents make it so that value is always
        // true...
        let children = state.collection.getChildren?.(node.key);
        hasChildRows = hasChildRows || [
            ...children ?? []
        ].length > 1;
        if (onAction == null && !hasLink && state.selectionManager.selectionMode === 'none' && hasChildRows) onAction = ()=>state.toggleKey(node.key);
        let isExpanded = hasChildRows ? state.expandedKeys.has(node.key) : undefined;
        let setSize = 1;
        if (node.level > 0 && node?.parentKey != null) {
            let parent = state.collection.getItem(node.parentKey);
            if (parent) {
                // siblings must exist because our original node exists
                let siblings = state.collection.getChildren?.(parent.key);
                setSize = [
                    ...siblings
                ].filter((row)=>row.type === 'item').length;
            }
        } else setSize = [
            ...state.collection
        ].filter((row)=>row.level === 0 && row.type === 'item').length;
        treeGridRowProps = {
            'aria-expanded': isExpanded,
            'aria-level': node.level + 1,
            'aria-posinset': node?.index + 1,
            'aria-setsize': setSize
        };
    }
    let { itemProps, ...itemStates } = (0, _selection.useSelectableItem)({
        selectionManager: state.selectionManager,
        key: node.key,
        ref,
        isVirtualized,
        shouldSelectOnPressUp: props.shouldSelectOnPressUp || shouldSelectOnPressUp,
        onAction: onAction || node.props?.onAction ? (0, _utils.chain)(node.props?.onAction, onAction ? ()=>onAction(node.key) : undefined) : undefined,
        focus,
        linkBehavior
    });
    let onKeyDownCapture = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        let walker = (0, _focus.getFocusableTreeWalker)(ref.current);
        walker.currentNode = document.activeElement;
        if ('expandedKeys' in state && document.activeElement === ref.current) {
            if (e.key === EXPANSION_KEYS['expand'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && !state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            } else if (e.key === EXPANSION_KEYS['collapse'][direction] && state.selectionManager.focusedKey === node.key && hasChildRows && state.expandedKeys.has(node.key)) {
                state.toggleKey(node.key);
                e.stopPropagation();
                return;
            }
        }
        switch(e.key){
            case 'ArrowLeft':
                if (keyboardNavigationBehavior === 'arrow') {
                    // Find the next focusable element within the row.
                    let focusable = direction === 'rtl' ? walker.nextNode() : walker.previousNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        // If there is no next focusable child, then return focus back to the row
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'rtl') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowRight':
                if (keyboardNavigationBehavior === 'arrow') {
                    let focusable = direction === 'rtl' ? walker.previousNode() : walker.nextNode();
                    if (focusable) {
                        e.preventDefault();
                        e.stopPropagation();
                        (0, _focus.focusSafely)(focusable);
                        (0, _utils.scrollIntoViewport)(focusable, {
                            containingElement: (0, _utils.getScrollParent)(ref.current)
                        });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        if (direction === 'ltr') {
                            (0, _focus.focusSafely)(ref.current);
                            (0, _utils.scrollIntoViewport)(ref.current, {
                                containingElement: (0, _utils.getScrollParent)(ref.current)
                            });
                        } else {
                            walker.currentNode = ref.current;
                            let lastElement = last(walker);
                            if (lastElement) {
                                (0, _focus.focusSafely)(lastElement);
                                (0, _utils.scrollIntoViewport)(lastElement, {
                                    containingElement: (0, _utils.getScrollParent)(ref.current)
                                });
                            }
                        }
                    }
                }
                break;
            case 'ArrowUp':
            case 'ArrowDown':
                // Prevent this event from reaching row children, e.g. menu buttons. We want arrow keys to navigate
                // to the row above/below instead. We need to re-dispatch the event from a higher parent so it still
                // bubbles and gets handled by useSelectableCollection.
                if (!e.altKey && ref.current.contains(e.target)) {
                    e.stopPropagation();
                    e.preventDefault();
                    ref.current.parentElement?.dispatchEvent(new KeyboardEvent(e.nativeEvent.type, e.nativeEvent));
                }
                break;
        }
    };
    let onFocus = (e)=>{
        keyWhenFocused.current = node.key;
        if (e.target !== ref.current) {
            // useSelectableItem only handles setting the focused key when
            // the focused element is the row itself. We also want to
            // set the focused key when a child element receives focus.
            // If focus is currently visible (e.g. the user is navigating with the keyboard),
            // then skip this. We want to restore focus to the previously focused row
            // in that case since the list should act like a single tab stop.
            if (!(0, _interactions.isFocusVisible)()) state.selectionManager.setFocusedKey(node.key);
            return;
        }
    };
    let onKeyDown = (e)=>{
        if (!e.currentTarget.contains(e.target) || !ref.current || !document.activeElement) return;
        switch(e.key){
            case 'Tab':
                if (keyboardNavigationBehavior === 'tab') {
                    // If there is another focusable element within this item, stop propagation so the tab key
                    // is handled by the browser and not by useSelectableCollection (which would take us out of the list).
                    let walker = (0, _focus.getFocusableTreeWalker)(ref.current, {
                        tabbable: true
                    });
                    walker.currentNode = document.activeElement;
                    let next = e.shiftKey ? walker.previousNode() : walker.nextNode();
                    if (next) e.stopPropagation();
                }
        }
    };
    let syntheticLinkProps = (0, _utils.useSyntheticLinkProps)(node.props);
    let linkProps = itemStates.hasAction ? syntheticLinkProps : {};
    // TODO: re-add when we get translations and fix this for iOS VO
    // let rowAnnouncement;
    // if (onAction) {
    //   rowAnnouncement = stringFormatter.format('hasActionAnnouncement');
    // } else if (hasLink) {
    //   rowAnnouncement = stringFormatter.format('hasLinkAnnouncement', {
    //     link: node.props.href
    //   });
    // }
    let rowProps = (0, _utils.mergeProps)(itemProps, linkProps, {
        role: 'row',
        onKeyDownCapture,
        onKeyDown,
        onFocus,
        // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
        'aria-label': node.textValue || undefined,
        'aria-selected': state.selectionManager.canSelectItem(node.key) ? state.selectionManager.isSelected(node.key) : undefined,
        'aria-disabled': state.selectionManager.isDisabled(node.key) || undefined,
        'aria-labelledby': descriptionId && node.textValue ? `${(0, _utils1.getRowId)(state, node.key)} ${descriptionId}` : undefined,
        id: (0, _utils1.getRowId)(state, node.key)
    });
    if (isVirtualized) {
        let { collection } = state;
        let nodes = [
            ...collection
        ];
        // TODO: refactor ListCollection to store an absolute index of a node's position?
        rowProps['aria-rowindex'] = nodes.find((node)=>node.type === 'section') ? [
            ...collection.getKeys()
        ].filter((key)=>collection.getItem(key)?.type !== 'section').findIndex((key)=>key === node.key) + 1 : node.index + 1;
    }
    let gridCellProps = {
        role: 'gridcell',
        'aria-colindex': 1
    };
    // TODO: should isExpanded and hasChildRows be a item state that gets returned by the hook?
    return {
        rowProps: {
            ...(0, _utils.mergeProps)(rowProps, treeGridRowProps)
        },
        gridCellProps,
        descriptionProps: {
            id: descriptionId
        },
        ...itemStates
    };
}
function last(walker) {
    let next = null;
    let last = null;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}

},{"@react-aria/utils":[["chain","ij7eS"],["getScrollParent","1Tu7U"],["mergeProps","aNvcY"],["scrollIntoViewport","1lzpw"],["useSlotId","jbI4Y"],["useSyntheticLinkProps","4FGnT"]],"@react-aria/focus":[["focusSafely","2ysUy"],["getFocusableTreeWalker","9oPIl"]],"./utils":"aJkqW","react":"a1TxN","@react-aria/interactions":"dkfxW","@react-aria/selection":"cJdJS","@react-aria/i18n":"4k4z8","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"hH0ym":[function(require,module,exports,__globalThis) {
/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid list.
 * @param props - Props for the selection checkbox.
 * @param state - State of the list, as returned by `useListState`.
 */ parcelHelpers.export(exports, "useGridListSelectionCheckbox", ()=>useGridListSelectionCheckbox);
var _grid = require("@react-aria/grid");
var _utils = require("./utils");
function useGridListSelectionCheckbox(props, state) {
    let { key } = props;
    const { checkboxProps } = (0, _grid.useGridSelectionCheckbox)(props, state);
    return {
        checkboxProps: {
            ...checkboxProps,
            'aria-labelledby': `${checkboxProps.id} ${(0, _utils.getRowId)(state, key)}`
        }
    };
}

},{"@react-aria/grid":"8WxyV","./utils":"aJkqW","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}],"8WxyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Provides the behavior and accessibility implementation for a selection checkbox in a grid.
 * @param props - Props for the selection checkbox.
 * @param state - State of the grid, as returned by `useGridState`.
 */ parcelHelpers.export(exports, "useGridSelectionCheckbox", ()=>useGridSelectionCheckbox);
// @ts-ignore
var _json = require("../intl/*.json");
var _jsonDefault = parcelHelpers.interopDefault(_json);
var _utils = require("@react-aria/utils");
var _i18N = require("@react-aria/i18n");
function useGridSelectionCheckbox(props, state) {
    let { key } = props;
    let manager = state.selectionManager;
    let checkboxId = (0, _utils.useId)();
    let isDisabled = !state.selectionManager.canSelectItem(key);
    let isSelected = state.selectionManager.isSelected(key);
    // Checkbox should always toggle selection, regardless of selectionBehavior.
    let onChange = ()=>manager.toggleSelection(key);
    const stringFormatter = (0, _i18N.useLocalizedStringFormatter)((0, _jsonDefault.default), '@react-aria/grid');
    return {
        checkboxProps: {
            id: checkboxId,
            'aria-label': stringFormatter.format('select'),
            isSelected,
            isDisabled,
            onChange
        }
    };
}

},{"../intl/*.json":"hdtsN","@react-aria/utils":"jbI4Y","@react-aria/i18n":"7lxyl","@parcel/transformer-js/src/esmodule-helpers.js":"3OmcS"}]},[], null, "parcelRequire7f0c", {})

//# sourceMappingURL=selection.912669af.js.map
